import type { MemoizedSelector, Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';

import type { FullCandidate } from '@recruitee/candidate-types';
import { filterBoolean } from '@recruitee/common';
import type { CandidateVisitedSnapshot } from '@recruitee/dashboard-types';
import { ResourceKind } from '@recruitee/dashboard-types';

const mapToRecentNavigationSnapshot = (candidate: FullCandidate): CandidateVisitedSnapshot => {
  const { id, name, hasAvatar, initials, photoThumbUrl, isAnonymous } = candidate;
  return {
    id,
    name,
    hasAvatar,
    initials,
    photoThumbUrl,
    kind: ResourceKind.Candidate,
    isAnonymous,
  };
};

export const candidateResolver = (
  store: Store,
  selector: MemoizedSelector<object, FullCandidate | null>,
): Observable<CandidateVisitedSnapshot> =>
  store.select(selector).pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
